import './ContainerView.css';
import { Container } from '@mui/material';

const ContainerView = ({ children, hasPreview, narrow }) => {
  return (
    <div className="container-view-wrapper">
      <Container
        maxWidth="lg"
        className={`container-view ${`${hasPreview ? 'has-preview' : 'no-preview'}`} ${narrow ? ' narrow' : ''}`}
        spacing={2}
      >
        {children}
      </Container>
    </div>
  )
}

export default ContainerView